// hooks/useApi.ts
import { useCallback } from "react";
import { useAuth0 } from "@auth0/auth0-react";

export const useApi = () => {
  const { getAccessTokenSilently } = useAuth0();

  // useCallback으로 안정화: 소비자가 useEffect/useCallback의 dep로 사용해도 무한 루프가 발생하지 않게 한다.
  const apiFetch = useCallback(async (
    input: RequestInfo,
    init: RequestInit = {}
  ): Promise<Response> => {
    const token = await getAccessTokenSilently({
        authorizationParams: {                    // ★ 여기 래퍼 추가
            audience: process.env.REACT_APP_API_BASE,
            scope:    "openid profile email offline_access read:estimates write:estimates profile:read profile:write",
        },
        detailedResponse: false,                  // 필요 시 다른 옵션
    });

    return fetch(input, {
      ...init,
      headers: {
        ...(init.headers || {}),
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  }, [getAccessTokenSilently]);

  return { apiFetch };
};
